import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, LanguageProvider } from './context/AppContext';
import Home from './pages/Home';
import Event from './pages/Event';
import Assistant from './pages/Assistant';
import Specs from './pages/Specs';
import AIFactory from './pages/AIFactory';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/event" element={<Event />} />
              <Route path="/aifactory" element={<AIFactory />} />
              <Route path="/assistant" element={<Assistant />} />
              <Route path="/specs/:token" element={<Specs />} />
            </Routes>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;